import { render, staticRenderFns } from "./RatingSummary.two.vue?vue&type=template&id=b31ef2a6"
import script from "./RatingSummary.two.vue?vue&type=script&lang=js"
export * from "./RatingSummary.two.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports